module.exports = __webpack_public_path__ + "static/img/10.0d54e8f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/1/eng/10.png
// module id = ijgl
// module chunks = 0